import {Component, Input, OnInit} from '@angular/core';
import {ColDef, ColumnApi, GridApi, GridReadyEvent} from 'ag-grid-community';
import {ShipmentInfo} from '../../../models/shipment-info.model';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';
import {AG_GRID_LOCALE_DE} from '../../../locale.de';
import {EmpfaengerdetailsComponent} from './empfaengerdetails/empfaengerdetails.component';
import {Dienst, Scannungen} from '../../../models';

@Component({
  selector: 'lib-sendungskette',
  templateUrl: './sendungskette.component.html',
  styleUrls: ['./sendungskette.component.css']
})
export class SendungsketteComponent implements OnInit {

  public gridApi: GridApi;
  public gridColumnApi: ColumnApi;
  public columnDef: ColDef[];
  public defaultColDef: ColDef;
  public carretUp = faCaretUp;
  public carretDown = faCaretDown;
  public show: boolean;

  public locale = AG_GRID_LOCALE_DE;

  public isCollapsed: boolean = false;

  @Input() sendungskette: ShipmentInfo[];


  constructor() {
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      flex: 1,
    };

    this.columnDef = [
      {
        field: 'absender',
        headerName: 'Versender',
      },
      {
        field: 'erfassungstag',
        headerName: 'Ü-Datum',
      },
      {
        field: 'sendungsnr',
        headerName: 'Sendungsnr',

      },
      {
        field: 'langreferenz',
        headerName: 'RefNr',

      },
      {
        headerName: 'Empfänger',
        cellRendererFramework: EmpfaengerdetailsComponent,
      },
      {
        field: 'colli',
        headerName: 'Col/Pal',
        maxWidth: 100,
        valueGetter: this.getColAndPal
      },
      {
        field: 'gesamtgewicht',
        headerName: 'Gewicht',
      },
      {
        headerName: 'Dienste',
        valueGetter: this.showDienste,
      },
      {
        headerName: 'Depot',
        valueGetter: this.showDepotNr,
        maxWidth: 100
      },
      {
        headerName: 'Tournr',
        valueGetter: this.showTourNr,
        maxWidth: 100
      },
    ];
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
    if (this.gridApi) {
      if (this.sendungskette.length > 0) {
        this.gridApi.setRowData(this.sendungskette);
        this.gridApi.hideOverlay();
      }
    }
  }

  gridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.sendungskette);
  }

  getColAndPal(params) {
    const colli = params.data.colli;
    const paletten = params.data.paletten;
    return colli + '/' + paletten;
  }

  showDienste(param: any) {
    const dienste = [];
    param.data?.dienste?.map((dienst: Dienst) => {
      if (dienst.anzeigeKuerzel !== null) {
        dienste.push(dienst.anzeigeKuerzel);
      }
    });
    return dienste.join(', ');
  }

  showDepotNr(param: any) {
    let depotnr = null;

    param.data?.scannungen?.map((scannungen: Scannungen) => {
      depotnr = scannungen.depotnr;
    });
    return depotnr;
  }

  showTourNr(param: any) {
    let tournr = '';

    param.data?.scannungen?.map((scannungen: Scannungen) => {
      tournr = scannungen.tournr;
    });
    return tournr;
  }

 
}
